import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Institution } from '../../models/global.types'

export interface InstitutionState {
  institution: Institution | null
}

export const institutionInitialState: InstitutionState = {
  institution: null
}

export const institutionSlice = createSlice({
  name: 'institution',
  initialState: institutionInitialState,
  reducers: {
    setInstitution: (state, action: PayloadAction<Institution>) => {
      state.institution = action.payload
    }
  }
})

export const {
  setInstitution
} = institutionSlice.actions

export default institutionSlice.reducer
